import types from '../utils/params.js'

let defaultState={
    user: {},
    audits: [],
    archives: [],
    auditsCalendarEvents: [],
    invoices: [],
    reports: [],
    listOfAuditTypes: [],
    isLoggedIn: null,
    listOfOrganisations: [],
    listOfQualifications: [],
    listOfMentions: [],
    openSnackbar:false,
    snackbarType:"",
    snackbarMsg:"",
    openConfirmation:false,
    confirmationTitle:"",
    confirmationCallback:null,
    confirmationMsg:"",
    userInfoMissing:false,
    surveysTemplates: [],
    loading: false,
}
const mainReducer = (state=defaultState, action) => {
  switch(action.type) {

    case types.UPDATE_LOADING: {
      return Object.assign({}, state, {
          loading: action.loading
      });
    }

    case types.UPDATE_USER: {
      return Object.assign({}, state, {
          user: action.user
      });
    }

    case types.USER_INFO_MISSING: {
      return Object.assign({}, state, {
          userInfoMissing: action.userInfoMissing
      });
    }

    case types.UPDATE_ISLOGGEDIN: {
      return{
          ...state,
          isLoggedIn:action.isLoggedIn
      }
    }

    case types.UPDATE_SURVEYS_TEMPLATES: {
      return Object.assign({}, state, {
          surveysTemplates: action.surveysTemplates
      });
    }

    case types.UPDATE_ORGANISATIONS: {
      return Object.assign({}, state, {
          listOfOrganisations: action.listOfOrganisations
      });
    }

    case types.UPDATE_QUALIFICATIONS: {
      return Object.assign({}, state, {
          listOfQualifications: action.listOfQualifications
      });
    }

    case types.UPDATE_MENTIONS: {
      return Object.assign({}, state, {
          listOfMentions: action.listOfMentions
      });
    }

    case types.SHOW_SNACKBAR: {
      return Object.assign({}, state, {
          openSnackbar: true,
          snackbarType:action.msg_type,
          snackbarMsg:action.message
      });
    }

    case types.CLOSE_SNACKBAR: {
      return Object.assign({}, state, {
          openSnackbar: false
      });
    }

    case types.SHOW_CONFIRMATION: {
      return Object.assign({}, state, {
          openConfirmation: true,
          confirmationTitle:action.title,
          confirmationMsg:action.message,
          confirmationCallback:action.callback
      });
    }

    case types.CLOSE_CONFIRMATION: {
      return Object.assign({}, state, {
          openConfirmation: false,
          confirmationTitle:"",
          confirmationMsg:"",
          confirmationCallback:null
      });
    }

      case types.ADD_AUDIT: {
          return Object.assign({}, state, {
              audits: [...state.audits, action.audit],
          });
      }

    case types.UPDATE_AUDIT: {
      const audit = state.audits.find(audit => audit.id === action.audit.id)
      if (!audit){
        return Object.assign({}, state, {
          audits: [...state.audits, action.audit]
        });
      } else {
        const updatedAudits = state.audits.map(audit => {
          if(audit.id === action.audit.id){
            return action.audit
          }
          return audit
        })
        return Object.assign({}, state, {
            audits: updatedAudits
        });
      }
    }

    case types.REMOVE_AUDIT: {
      const updatedAudits = state.audits.filter(audit => {return audit.id !== parseInt(action.audit, 10)})
      return Object.assign({}, state, {
          audits: updatedAudits
      });
    }

    case types.UPDATE_AUDITS: {
      return Object.assign({}, state, {
          audits: action.audits
      });
    }

      case types.UPDATE_ARCHIVE: {
          const archive = state.archives.find(archive => archive.id === action.archive.id)
          if (!archive){
              return Object.assign({}, state, {
                  archives: [...state.archives, action.archive]
              });
          } else {
              const updatedArchives = state.archives.map(archive => {
                  if(archive.id === action.archive.id){
                      return action.archive
                  }
                  return archive
              })
              return Object.assign({}, state, {
                  archives: updatedArchives
              });
          }
      }

      case types.REMOVE_ARCHIVE: {
          const updatedArchives = state.archives.filter(archive => {return archive.id !== parseInt(action.audit, 10)})
          return Object.assign({}, state, {
              archives: updatedArchives
          });
      }

      case types.UPDATE_ARCHIVES: {
          return Object.assign({}, state, {
              archives: action.archives
          });
      }

      case types.UPDATE_CALENDAR_EVENTS: {
          return Object.assign({}, state, {
              auditsCalendarEvents: action.events
          });
      }

    case types.UPDATE_AUDITTYPES: {
      return Object.assign({}, state, {
          listOfAuditTypes: action.listOfAuditTypes
      });
    }

    case types.ADD_INVOICE: {
      return Object.assign({}, state, {
          invoices: [...state.invoices, action.invoice],
      });
    }

    case types.REMOVE_INVOICE: {
      const updatedInvoices = state.invoices.filter(invoice => {return invoice.id !== action.id})
      return Object.assign({}, state, {
          invoices: updatedInvoices
      });
    }

    case types.UPDATE_INVOICE: {
      const invoice = state.invoices.find(invoice => invoice.id === action.invoice.id)

      if (!invoice){
        return Object.assign({}, state, {
          invoices: [...state.invoices, action.invoice]
        });
      } else {
        const updatedInvoices = state.invoices.map(invoice => {
          if(invoice.id === action.invoice.id){
            return action.invoice
          }
          return invoice
        })
        return Object.assign({}, state, {
            invoices: updatedInvoices
        });
      }
    }

    case types.UPDATE_INVOICES: {
      return Object.assign({}, state, {
          invoices: action.invoices
      });
    }

    case types.REMOVE_REPORT: {
      const updatedReports = state.reports.filter(report => {return report.id !== action.id})
      return Object.assign({}, state, {
          reports: updatedReports
      });
    }

    case types.UPDATE_REPORT: {
      const report = state.reports.find(report => report.id === action.report.id)

      if (!report){
        return Object.assign({}, state, {
          reports: [...state.reports, action.report]
        });
      } else {
        const updatedReports = state.reports.map(report => {
          if(report.id === action.report.id){
            return action.report
          }
          return report
        })
        return Object.assign({}, state, {
            reports: updatedReports
        });
      }
    }

    case types.UPDATE_REPORTS: {
      return Object.assign({}, state, {
          reports: action.reports
      });
    }

    case types.UPDATE_DOCUMENT: {
      let reports = Object.assign({}, state).reports;
      let report = reports.find(report => report.id === action.report.id)
      let document = report.documents.find(document => document.id === action.document.id)

      if (!document){
        return Object.assign({}, report, {
          documents: [...state.documents, action.document]
        });
      } else {
        const updatedDocuments = report.documents.map(document => {
          if(document.id === action.document.id){
            return action.document
          }
          return document
        })
        reports.documents = updatedDocuments;
        return Object.assign({}, state, {
            reports: reports
        });
      }
    }

    case types.REMOVE_DOCUMENT: {
      const updatedReports = state.reports.map(report => {
        if(report.id === action.report.id) {
          const updatedDocuments = report.documents.filter(document => document.id !== action.id)
          report.documents = updatedDocuments;
        }
        return report
      })
      return Object.assign({}, state, {
          reports: updatedReports
      });
    }
    case types.ADD_SURVEY_TO_REPORT: {
      const updatedReports = state.reports.map(report => {
          if(report.id === action.report_id){
              let new_report = Object.assign({}, report);
              new_report.surveys = [...report.surveys, action.survey];
              return new_report;
          }
          return report
      })
      return Object.assign({}, state, {
          reports: updatedReports
      });
    }

      case types.UPDATE_SURVEY_TO_REPORT: {
          const updatedReports = state.reports.map(report => {
              if(report.id === action.report_id){
                  let new_report = Object.assign({}, report);
                  new_report.surveys = new_report.surveys.map(survey => {
                      if(survey.id === action.survey.id){
                          return action.survey;
                      }else{
                          return survey;
                      }
                  });
                  return new_report;
              }
              return report
          })
          return Object.assign({}, state, {
              reports: updatedReports
          });
      }

    case types.ADD_DOCUMENT_TO_REPORT: {
      const updatedReports = state.reports.map(report => {
        if(report.id === action.report){
          let new_report = Object.assign({}, report);
          new_report.documents = [...report.documents, action.document];
          return new_report;
        }
        return report
      })
      return Object.assign({}, state, {
          reports: updatedReports
      });
    }

      case types.UPDATE_SURVEY: {
          let reports = Object.assign({}, state).reports;
          let report = reports.find(report => report.id === action.report.id)
          let survey = report.surveys.find(survey => survey.id === action.survey.id)

          if (!survey){
              return Object.assign({}, report, {
                  surveys: [...state.surveys, action.survey]
              });
          } else {
              const updatedSurveys = report.surveys.map(survey => {
                  if(survey.id === action.survey.id){
                      return action.survey
                  }
                  return survey
              })
              reports.surveys = updatedSurveys;
              return Object.assign({}, state, {
                  reports: reports
              });
          }
      }

    default: return state;
  }
}

export default mainReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js